const INITIAL_STATE = {
  data: {},
  errors: {},
}

const deleteCard = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'DELETE_CARD':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'DELETE_CARD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default deleteCard;
